import React from 'react'
import {backgroundDark,backgroundLight} from "../assets/images"
import { useStateContext } from '../context/ContextProvider'
import { Footer, Header } from '../components/layout'
import { AboutUSTimeline, AboutUsHero } from '../components/AboutUs'



const AboutUs = () => {
    const {currentMode,currentLang}=useStateContext()
    const bgImage = currentMode === 'Dark' ? backgroundDark : backgroundLight;
  return (
    <div className='bg-light-primary dark:bg-dark-primary'
  
    > <Header activeLink={"/AboutUS"} />
    <AboutUsHero />
<AboutUSTimeline />
          <Footer />
        </div>
  )
}

export default AboutUs